import request from '@/api/request';

//上报页面访问（后台访问统计 PV/UV 数据来源，失败静默处理）
export async function AddAccessLog(data) {
    try {
        await request.post('/AddAccessLog', data);
    } catch (e) {
        // 统计上报不影响页面功能，忽略错误
    }
}
